export default 'prod-milano'
